import type {MeshEntry} from "#pricing/types/pricing-types"
import {meshEntrySchema} from "#pricing/types/pricing-types"
import {PricingNode, registerPricingGraphNode} from "#pricing/pricing-node"
import type {GraphNodeDefinition} from "@cm/graph-v3"
import {z} from "zod/v4-mini"

export type MeshesNodeParameters = {
    meshes: MeshEntry[]
}

export function aggregateMeshEntries(meshes: {name: string; path: string}[]): MeshEntry[] {
    const byName = new Map<string, MeshEntry>()
    for (const mesh of meshes) {
        const existing = byName.get(mesh.name)
        if (existing) existing.amount += 1
        else byName.set(mesh.name, {name: mesh.name, path: mesh.path, amount: 1})
    }
    return [...byName.values()]
}

const meshesNodeDefinition = {
    nodeClass: "MeshesNode",
    validation: {
        parameters: z.object({
            meshes: z.array(meshEntrySchema),
        }),
        returns: z.array(meshEntrySchema),
    },
} satisfies GraphNodeDefinition<MeshEntry[], MeshesNodeParameters>

@registerPricingGraphNode
export class MeshesNode extends PricingNode<MeshEntry[], MeshesNodeParameters> {
    public override get definition(): GraphNodeDefinition<MeshEntry[], MeshesNodeParameters> {
        return meshesNodeDefinition
    }

    override run = async () => {
        return this.parameters.meshes
    }

    setMeshes(meshes: MeshEntry[]) {
        this.updateParameters({meshes})
    }

    clearMeshes() {
        this.updateParameters({meshes: []})
    }
}
